var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGodown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9358 20.4732C14.3648 20.0238 15.0769 20.0072 15.5264 20.4362L22.7406 27.3226C22.8856 27.4609 23.1136 27.4609 23.2585 27.3226L30.4728 20.4362C30.9222 20.0072 31.6343 20.0238 32.0634 20.4732C32.4924 20.9227 32.4758 21.6348 32.0264 22.0638L24.8121 28.9501C23.7977 29.9184 22.2014 29.9184 21.1871 28.9501L13.9728 22.0638C13.5234 21.6348 13.5068 20.9227 13.9358 20.4732Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGodown);
export default __webpack_public_path__ + "static/media/go down.6a750141c6126f1c4f45de098aaa9f1a.svg";
export { ForwardRef as ReactComponent };